$(document).ready(function () {

  $('.multi-column--blog-carousel').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button class="button-slider slide-arrow prev-arrow"><span class="visually-hidden">Previous</span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-left" aria-hidden="true" focusable="false" role="presentation"><path d="m15 18-6-6 6-6"></path></svg></button>',
    nextArrow: '<button class="button-slider slide-arrow next-arrow"><span class="visually-hidden">Next</span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-right" aria-hidden="true" focusable="false" role="presentation"><path d="m9 18 6-6-6-6"></path></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  });

  $('.multi-column--tabs').slick({
    arrows: false,
    variableWidth: true,
    infinite: false,
    draggable: false,
    swipe: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          variableWidth: false,
          slidesToShow: 2,
          infinite: true,
          arrows: true,
          prevArrow: '<button class="button-slider slide-arrow prev-arrow"><span class="visually-hidden">Previous</span><svg xmlns="http://www.w3.org/2000/svg" width="23.544" height="39.04" viewBox="0 0 23.544 39.04"><g transform="translate(1.975 0.976)"><path d="M14.751,38.064-1.975,18.544,14.751-.976,17.029.976,1.975,18.544,17.029,36.112Z"/><path d="M14.751,38.064-1.975,18.544,14.751-.976,17.029.976,1.975,18.544,17.029,36.112Z" transform="translate(4.54)" fill="#fff"/></g></svg></button>',
          nextArrow: '<button class="button-slider slide-arrow next-arrow"><span class="visually-hidden">Next</span><svg xmlns="http://www.w3.org/2000/svg" width="23.544" height="39.04" viewBox="0 0 23.544 39.04"><g transform="translate(1.139 0.976)"><path d="M1.139,38.064l-2.278-1.952L13.914,18.544-1.139.976,1.139-.976l16.726,19.52Z" transform="translate(4.54)"/><path d="M1.139,38.064l-2.278-1.952L13.914,18.544-1.139.976,1.139-.976l16.726,19.52Z" fill="#fff"/></g></svg></button>',
        }
      },
    ]
  });

  $('.multi-column--tabs').on('afterChange', function () {
    $('.slick-slide.slick-current .multi-column--tab div[data-index]').click();
  });

  $('div[data-index]').on('click', function () {
    $(".multi-column--tab").removeClass("active");
    $(this).parent().addClass("active");

    $(".multi-column--tab-trigger").removeClass("active");
    var dataid = $(this).attr("data-filter");

    $('.multi-column--tab-trigger').each(function (index) {
      if ($(this).attr('data-tab-id') == dataid) {
        $(this).addClass('active');
      }
    });
  });

});